export default ($resource) => {
    const url = `${SEED_CORE.ENV.API_URL}tasklist/task/:id`;

    return $resource(url, null, {
        update: {
            method: 'PUT',
            url
        }
    });
};



// WEBPACK FOOTER //
// ./src/app/resources/TasklistTask/index.js